import { buildCreateSlice, asyncThunkCreator } from '@reduxjs/toolkit';
import { initialState } from './initial';
import { reducers } from './reducers';

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const authSlice = createAppSlice({
  name: 'auth',
  initialState,
  reducers,
});

export const {
  setToken,
  setUser,
  setChannels,
  setSigningIn,
  setSignInFailure,
  forgotPassword,
  setUpdatePasswordLoading,
  setUpdatePasswordError,
  setUpdatePasswordSuccess,
  setTempProfile,
  setTwoFactorStored,
  setPhoneHash,
  setRequestPhone,
  setOnboardedLoading,
  setAwaitCode,
  setChangingChannels,
  setChannelSSO,
  fetchChannelsInfo,
  fetchReducedUser,
  signIn,
  refreshToken,
  confirmCode,
  getAdminChannels,
  signOut,
} = authSlice.actions;

export default authSlice.reducer;
